// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_2LHRS","button":"view-header_button_1TLmR","active":"view-header_active_2978n","btnExport":"view-header_btnExport_VhT_X","mr":"view-header_mr_2iAUF"};